
<template>
  <button
    class="t-button u-inline-block u-cursor-pointer u-center t-cta"
    :class="{
      'is-ghost': ghost,
      'is-main': main,
      'is-icon': icon,
      'is-second': second
    }"
  >
    <template v-if="url !== ''" >
      <a v-if="isUrlAbsolute" :href="url" target="_blank" class="u-relative" :class="metaClass">
        <slot/>
      </a>
      <router-link v-else :to="url" class="u-relative" :class="metaClass">
        <slot/>
      </router-link>
    </template>
    <router-link v-else-if="to.name" :to="to" class="u-relative" :class="metaClass">
      <slot/>
    </router-link>
    <span v-else class="u-relative" :class="metaClass">
      <slot/>
    </span>
  </button>
</template>

<script>
import Button from './Button'

export default {
  mixins: [Button],

  computed: {
    metaClass () {
      let classs =  this.icon ? 'u-row u-center u-middle' : ''

      classs += ' t-cta'

      return classs + ' u-relative t-bold ' + this.innerClass
    }
  },

  props: {
    icon: {
      type: Boolean,
      default: false
    },
    main: {
      type: Boolean,
      default: false
    },
    second: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },
    innerClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/easings'

.t-button
  z-index 0
  position relative
  color: $colors.second-color
  background-color transparent
  viewportSizer('padding-left', 30, 1920, 20px, 40px)
  viewportSizer('padding-right', 30, 1920, 20px, 40px)
  viewportSizer('padding-top', 15, 1920, 10px, 20px)
  viewportSizer('padding-bottom', 15, 1920, 10px, 20px)

  &:after
    content ''
    z-index -1
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    border-radius 100px
    background-color: $colors.white
    transition: transform .5s ease-in-out-quart
  
  &.is-icon svg
    width 1.5em
    height 1.5em

  &.is-main
    color: $colors.white

    &:after
      background-color: $colors.main-color

  &.is-second
    color: $colors.white

    &:after
      background-color: $colors.second-color

  &.is-ghost
    color: $colors.white

    &:after
      border: solid 2px $colors.white
      background-color: transparent

  &.is-ghost.is-main
    color: $colors.main-color

    &:after
      border: solid 2px $colors.main-color
      background-color: transparent

  &.is-ghost.is-second
    color: $colors.second-color

    &:after
      border: solid 2px $colors.second-color
      background-color: transparent
  
+mq($from: 'tablet')
  .t-button:hover:after
        transform scale(1.1, 1.1)

@keyframes shiny
  0%
    transform: translateZ(0) scale(.9)
    opacity 0
  40%
    opacity 1

  100%
    transform: translateZ(0) scale(1.3)
    opacity 0
</style>
